<template>
  <div class="dropdown notifications noti">
    <button
        class="btn btn-secondary border-0 p-0 position-relative badge"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
    >
      <span class="material-symbols-outlined">notifications</span>
    </button>

    <div class="dropdown-menu dropdown-lg p-0 border-0 p-0 dropdown-menu-end">
      <div class="d-flex justify-content-between align-items-center title">
        <span class="fw-semibold fs-15 text-secondary">Обновления<span class="fw-normal text-body fs-14"> </span> </span>
        <button class="p-0 m-0 bg-transparent border-0 fs-14 text-primary"></button>
      </div>

      <div class="max-h-250" data-simplebar>
<!--        <div class="notification-menu unseen-">
          <a
              v-for="(notification, index) in nots"
              :key="notification.id"
              href="/notifications"
              class="dropdown-item"
          >
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <i class="material-symbols-outlined text-primary">sms</i>
              </div>
              <div class="flex-grow-1 ms-3">
                <p>{{ notification.action }}</p>
                <span class="fs-13">{{ formatRelativeTime(notification.created_at) }}</span>
              </div>
            </div>
          </a>
        </div>-->
      </div>

<!--      <RouterLink
          to="/notifications"
          class="dropdown-item text-center text-primary d-block view-all fw-medium rounded-bottom-3"
      >
        <span>Все обновления</span>
      </RouterLink>-->
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import feather from "feather-icons";
import { fetchNots } from "@/api/notification";  // Assuming you have an API method to fetch notifications

export default defineComponent({
  name: "NotificationsLists",
  setup() {
    const nots = ref([]); // Set initial value to an empty array

    const formatRelativeTime = (dateString) => {
      const date = new Date(dateString);
      const now = new Date();
      const diffInSeconds = Math.floor((now - date) / 1000);

      const rtf = new Intl.RelativeTimeFormat("ru", { numeric: "auto" });

      if (diffInSeconds < 60) {
        return rtf.format(-diffInSeconds, "seconds"); // For seconds
      } else if (diffInSeconds < 3600) {
        return rtf.format(-Math.floor(diffInSeconds / 60), "minutes"); // For minutes
      } else if (diffInSeconds < 86400) {
        return rtf.format(-Math.floor(diffInSeconds / 3600), "hours"); // For hours
      } else if (diffInSeconds < 2592000) {
        return rtf.format(-Math.floor(diffInSeconds / 86400), "days"); // For days
      } else if (diffInSeconds < 31536000) {
        return rtf.format(-Math.floor(diffInSeconds / 2592000), "months"); // For months
      } else {
        return rtf.format(-Math.floor(diffInSeconds / 31536000), "years"); // For years
      }
    };

    onMounted(() => {
      feather.replace(); // Initialize Feather icons

      // Fetch notifications and slice the last 3
      fetchNots().then((response) => {
        console.log("nots");
        nots.value = response.histories.slice(0, 3); // Limit to 3 notifications
      });
    });

    return {
      nots,
      formatRelativeTime,
    };
  },
});
</script>

<style scoped>
.max-h-250 {
  min-height: 250px; /* Increase the min-height */
}
</style>
